import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import Grafici from "@/pages/Grafici";
import Storico from "@/pages/Storico";
import Previsioni from "@/pages/Previsioni";
import Stazione from "@/pages/Stazione";
import Contatti from "@/pages/Contatti";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/grafici" element={<Grafici />} />
            <Route path="/storico" element={<Storico />} />
            <Route path="/previsioni" element={<Previsioni />} />
            <Route path="/stazione" element={<Stazione />} />
            <Route path="/contatti" element={<Contatti />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
